import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const CanExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Can/Could</h2>

      <p>
        Modal verbs help us express <strong>ability</strong>, <strong>permission</strong>, <strong>possibility</strong>, <strong>advice</strong>, and <strong>necessity</strong>. The main modals are <strong>can, could, may, might, must, should, will, would</strong>, and <strong>ought to</strong>. They are followed directly by the base form of a verb.
      </p>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Ability</h3>
          <ul>
            <li><strong>Can</strong> = ability to do something<br /><em>I can swim.</em></li>
            <li><strong>Could</strong> = past ability (or a polite question)<br /><em>She could speak French.</em> / <em>Could you help me?</em></li>
            <li><strong>Be able to</strong> = ability in different tenses<br /><em>I was able to finish on time.</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Permission</h3>
          <ul>
            <li><strong>Can</strong> = permission (informal)<br /><em>Can I use your phone?</em></li>
            <li><strong>May</strong> = permission (more formal)<br /><em>May I leave the room?</em></li>
            <li><strong>Could</strong> = polite permission<br /><em>Could I join you?</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Possibility & Advice</h3>
          <ul>
            <li><strong>May / Might</strong> = something is possible<br /><em>It might rain.</em></li>
            <li><strong>Should / Ought to</strong> = advice<br /><em>You should eat more fruit.</em></li>
            <li><strong>Could</strong> = a possible suggestion<br /><em>We could go to the cinema.</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Necessity</h3>
          <ul>
            <li><strong>Must</strong> = strong necessity (speaker's belief)<br /><em>You must wear a seatbelt.</em></li>
            <li><strong>Have to</strong> = necessity (not the speaker's belief)<br /><em>I have to work late tonight.</em></li>
            <li><strong>Don't have to</strong> = no necessity<br /><em>You don't have to come.</em></li>
          </ul>
        </div>
      </div>

      <div className="grammar-explanation-text">
        <h3><FaLightbulb /> Notes</h3>
        <ul>
          <li>Modal verbs never change form — you cannot add <em>-s</em> even with <strong>he</strong> or <strong>she</strong> (<em>She <strong>can</strong> swim</em>, not <em>*cans</em>).</li>
          <li>There is no infinitive or participle form of modals. Use <strong>be able to</strong>, <strong>have to</strong>, or <strong>suffice</strong> instead.</li>
          <li>Questions and negatives are made by adding <strong>not</strong> or inverting the subject directly.</li>
        </ul>
        <p><strong>Examples:</strong></p>
        <ul>
          <li>She <strong>can</strong> play tennis. (affirmative)</li>
          <li>She <strong>cannot / can't</strong> play tennis. (negative)</li>
          <li><strong>Can</strong> she play tennis? (question)</li>
        </ul>
      </div>
    </div>
  );
};

export default CanExplanation;
